/**
 * Communio chrome tokens. Web CSS variables and the Expo app both read these.
 * Hosts may still override hue in theme settings.
 */

/** Forest green from the mobile header and app icon field. */
export const COMMUNIO_BRAND_HUE = '162';

export const COMMUNIO_INK = '#0B3D2E';
export const COMMUNIO_INK_ON_BRAND = '#FFFFFF';
export const COMMUNIO_MUTED_ON_BRAND = '#B8D4C6';
export const COMMUNIO_CANVAS = '#F4F7F5';
export const COMMUNIO_DANGER = '#8B2E2E';

/** WCAG / platform touch minimum. */
export const TOUCH_MIN_PX = 44;

/** Cap system text scaling so headers stay tappable. */
export const FONT_SCALE_CAP = 1.3;
